import { LocaleEnum } from '@systemeio/ui'

export const getHelpPageLinkActiveCampaign = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.FRENCH:
      return 'https://aide.systeme.io/article/1671-comment-integrer-activecampaign-avec-systeme-io'
    case LocaleEnum.SPANISH:
      return 'https://help-es.systeme.io/article/1603-como-integrar-activecampaign-con-systeme-io'
    case LocaleEnum.ITALIAN:
      return 'https://help-it.systeme.io/article/1595-come-integrare-activecampaign-con-systeme-io'
    case LocaleEnum.PORTUGUESE:
      return 'https://help-pt.systeme.io/article/1954-como-integrar-a-activecampaign-com-a-systeme-io'
    case LocaleEnum.DEUTSCH:
      return 'https://help-de.systeme.io/article/1591-so-integrieren-sie-activecampaign-mit-systeme-io'
    case LocaleEnum.DUTCH:
      return 'https://help-nl.systeme.io/article/1833-hoe-integreer-je-activecampaign-met-systeme'
    case LocaleEnum.JAPANESE:
      return 'https://help-jp.systeme.io/article/2236-how-to-integrate-activecampaign-with-systeme-io'
    case LocaleEnum.ARABIC:
      return 'https://help-ar.systeme.io/article/2750-how-to-integrate-activecampaign-with-systemeio'
    case LocaleEnum.TURKISH:
      return 'https://help-tr.systeme.io/article/3842-activecampaign-systeme-io-ile-nasil-entegre-edilir'
    case LocaleEnum.CHINESE:
      return 'https://help-zh.systeme.io/article/3122-how-to-integrate-activecampaign-with-systeme-io'
    case LocaleEnum.HINDI:
      return 'https://help-hi.systeme.io/article/3536-how-to-integrate-activecampaign-with-systeme-io'
    default: {
      return 'https://help.systeme.io/article/1573-how-to-integrate-activecampaign-with-systeme-io'
    }
  }
}
